module.exports = __webpack_public_path__ + "img/diem.298a659e.png";